import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { AccessRightDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-access-right-container',
  templateUrl: './access-right-container.component.html',
  styleUrls: ['./access-right-container.component.scss'],
})
export class AccessRightContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  accessrights$: Observable<AccessRightDto[]>;
  loading: boolean;
  isLoadingAccessRight$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingAccessRight$ = this.gatwayFacade.isLoadingGateway(
      'AccessRight'
    );
    this.accessrights$ = this.gatwayFacade.loadGateway('AccessRight');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAccessRight(deletedValue: any) {
    this.gatwayFacade.remove('AccessRight', deletedValue);
  }

  // this method control both the create and update

  onSubmitAccessRight(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.AccessRights;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllAccessRight = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllAccessRight.push(pullData[i]);
      }
    }

    // check if the addAllAccessRight array is not empty, then dispatch the data to the store
    if (addAllAccessRight.length > 0) {
      this.gatwayFacade.add('AccessRight', addAllAccessRight);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('AccessRight', allUpdates, ['id']);
    }
  }
}
